export function websiteCtaUrl(value) {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw || /[\u0000-\u0020\u007f]/.test(raw)) return null;
  try {
    const url = new URL(raw);
    if (["https:", "http:"].includes(url.protocol)) return url.hostname && !url.username && !url.password ? url.href : null;
    if (url.protocol === "mailto:" && /^[^?@]+@[^?@]+\.[^?@]+$/.test(url.pathname)) return raw;
    if (url.protocol === "tel:" && /^\+?[\d().-]{5,}$/.test(url.pathname)) return raw;
  } catch { /* Invalid destinations are not clickable. */ }
  return null;
}

export function publicPageFailure(status) {
  return status === 404 ? "not_found" : "unavailable";
}
